module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This book grew")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from many different soils,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with pages sprouting in")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("New Jersey")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("New York")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Pennsylvania")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Connecticut")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("South Carolina")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("California")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Colorado")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Hawaii")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Mexico")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Italy")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Spain")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("France")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Ebook-TOC",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("rigger Warning (TW):")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Mental illness, death, drug use, violence, miscarriage")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("&")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The poem ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-1"
  }, [_vm._v("“Ten Little Girls”")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" includes the topics "), _c('br'), _vm._v("of ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sexual assault, suicide, eating disorders, "), _c('br'), _vm._v("body shaming, kidnapping, weapons, "), _c('br'), _vm._v("death/murder, and drug use.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t2"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I think you should be nervous about")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("what I will accomplish once I heal.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The mountains I’ll move.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The miles I’ll cover.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The skin I’ll get under.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-5"
  }, [_vm._v("Stuff I’ve Been Feeling Lately")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t3"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("We are all recovering from something.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("This is for all of us.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('div', {
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/pxii.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "Ebook-TOC",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("EP Track List")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor004"
    }
  }, [_vm._v("Lampyridae & Our Bioluminescence")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor005"
    }
  }, [_vm._v("The Denouement")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor006"
    }
  }, [_vm._v("Collateral Beauty")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor007"
    }
  }, [_vm._v("Hypnic Jerk")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor008"
    }
  }, [_vm._v("Some Piranhas Are Vegetarians")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor009"
    }
  }, [_vm._v("The ’90s Seem So Long Ago")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor010"
    }
  }, [_vm._v("Fits")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor011"
    }
  }, [_vm._v("I Am Marked")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor012"
    }
  }, [_vm._v("Hemlock Falls & Fairy Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor013"
    }
  }, [_vm._v("Saturday-Morning Cartoons")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor014"
    }
  }, [_vm._v("Riviera Maya")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor015"
    }
  }, [_vm._v("Wandering, Wondering")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor016"
    }
  }, [_vm._v("Rome & My Ruins")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor017"
    }
  }, [_vm._v("Disquietude")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor018"
    }
  }, [_vm._v("There’s the Rub")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor019"
    }
  }, [_vm._v("Amalfi Coast")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor020"
    }
  }, [_vm._v("If Only Romeo Were Running Late \tto Her Funeral")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor021"
    }
  }, [_vm._v("Pressed Dandelions")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor022"
    }
  }, [_vm._v("Dive")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor023"
    }
  }, [_vm._v("Absent")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor024"
    }
  }, [_vm._v("“I Am Sorry for Your Loss”")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor025"
    }
  }, [_vm._v("Mellifluous Monotony ")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor026"
    }
  }, [_vm._v("Obsequious")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor027"
    }
  }, [_vm._v("Broken Hearts & Brokenhearted People")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor028"
    }
  }, [_vm._v("Traffic, Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor029"
    }
  }, [_vm._v("Basilicata")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor030"
    }
  }, [_vm._v("Check & Mate")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor031"
    }
  }, [_vm._v("Day at Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor032"
    }
  }, [_vm._v("A Meteorological Phenomenon")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor033"
    }
  }, [_vm._v("Hard of Hearing")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor034"
    }
  }, [_vm._v("The Send-Off & Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor035"
    }
  }, [_vm._v("Glimmers")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Lampyridae & Our Bioluminescence")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The short years when we were children,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we would chase fireflies around the yard.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We would capture one and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("peel the sticky light from its skin.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We would wear it on our fingers")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("like glowing diamonds; trophies.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("How cruel I was to steal the light from this creature.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("How naive I was to believe no one would ever")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("try to steal my light away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("How resilient I am to keep shining anyway.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("The Denouement")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" sick and tired")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" of swallowing the blood")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" from biting my own tongue")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" just so you do not have to")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" swallow your pride.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But I am not like you;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I am not a destroyer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I toy with the truths")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I keep trapped behind my lips.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I mix them with my saliva until")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" they are as smooth as river stones.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("All I need to do")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" is skip them across")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" the sound barrier and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" you’d be exposed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But I am not like you;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I am not a killer.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Collateral Beauty")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tragedy leaks into the buckets of our bodies.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We don’t realize we’re cracked until")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we’ve flooded and the pressure releases,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("pouring out in tears from our eyes and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("screams from our throats and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("anger from our clenched fists and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("prayers from our bended knees.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It is those same unassuming cracks")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("where grace enters to replenish us through")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the light from our eyes and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the songs from our voices and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the humanity from our outstretched arms and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the new chapters from our forward-marching feet.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Hypnic Jerk")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I find my voice is tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My vocal cords strained")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from screaming over ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my own self-doubt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I find my voice is tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I find my heart is tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Each tick takes effort,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("forced and erratic,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("much like my smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I find my heart is tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I find my mind is tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thoughts arrive slowly,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("steering through the fog")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of my murky brain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I find my mind is tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I find my eyes are tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Each blink is heavy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("yearning to just sleep")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("some time away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I find my eyes are tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I trust the process. I let them all rest.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("Some Piranhas Are Vegetarians")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I switch the song on the radio")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("because it reminds me of you and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t feel like visiting you today.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My mind understands the feelings")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("evoked by the music are illusions,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but try telling that to my soul.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("You were not my person.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("You were my lesson.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("You were . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("You were . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You were the piranha, circling.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I discovered too late that you ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("made a habit of attacking people")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with hearts much larger than yours.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("The ’90s Seem So Long Ago")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The smell of peeled oranges")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("makes me think of Thanksgiving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The crisp crunch of raw celery")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and the aroma of steam")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rising from radiators reminds me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of my father on Christmas.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My childhood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I used to breathe here.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Impatiently.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Now I look back,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fondly,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("missing the sounds of a")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("crowded home with love")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and arguments")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and dogs yapping.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I remember it all,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("eyes closed tight,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("angry with myself that")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was ever impatient.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("Fits")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I outgrew you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It saddened me greatly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Like outgrowing ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a favorite sweater")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wished still fit")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("because the fibers")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("felt so familiar and soft")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("against my skin.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But your mistakes")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("became your patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and your patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("never looked good on me.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("I Am Marked")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They all can see")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that I carry")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("what no one will address.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The guilt, the shame,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve had enough,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I want to catch my breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The elephant")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("here in this room")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is sitting on my chest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And unbeknownst")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to everyone,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("he’s crushing me to death.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("Hemlock Falls & Fairy Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Everything is greener at the top of New Jersey,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("including your eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The waterfall is falling how I was;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fast, without remorse, naturally.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Once you sit down by the falls, I do the same,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("putting a safe distance between me and you and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("your hands and the spray of the water.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You notice the distance between us and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bait me to close                the                  gap.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I stay put, blaming the puddle that formed between "), _c('br'), _vm._v("us from the early morning rain. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I’m not afraid of a little water")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", you say and move closer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Me either,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I say, blowing my cover.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("Saturday-Morning Cartoons")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("There’s always a bad guy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a three-year-old tells me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("between playing with my thumb,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("referring to a children’s show.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He doesn’t know much of anything yet,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but he knows this to be certain:")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("There’s always a bad guy.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("Riviera Maya")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My lips have touched")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so many salt-rimmed glasses today,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("they have started to prune.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am reminded of bath-soaked fingers and toes. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I live 1.2 miles from the hospital where I was born, "), _c('br'), _vm._v("and flew to Mexico to watch two children of divorce")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("vow never to end up like their parents.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A testament to remembering where you came from,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but understanding you do not have to stay there.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Wandering, Wondering")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We are walking")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("across the uncut grass.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I, barefoot,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you, in shoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This is how we differ.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Do you ever wonder how many")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("four-leaf clovers we are crushing?")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I ask.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Probably not a lot")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", you say.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This is where we differ.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("Rome & My Ruins")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("After I am gone,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my words will be excavated.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dug up,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("dusted off,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("preserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My cross-outs that never became thoughts,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my thoughts that never became words.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Perhaps a lingering eyelash or")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("finger smudge will reveal itself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And my words will be shared,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I will speak again.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Head-Flush-Leftn ParaOverride-3 t2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v("Disquietude")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I let the rain collect")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on the windshield because")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the noise from the wipers hurts my ears.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-3 t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I let you remain in")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the passenger seat for")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("another day because the sound")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of goodbye hurts my heart.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v("There’s the Rub")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You were weak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You were weak, and you gave up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You were weak and took the coward’s way out.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You were weak, and you left without a word.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("It doesn’t take much strength")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("to slam the door")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("of an empty room.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was strong, and I locked it behind you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was strong, and I cried.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was strong, and I moved on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was strong.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v("Amal")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("f")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("i Coast")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wash the Mediterranean Sea from my hair,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it slicks down my face,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("drips from my nose to my lips.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I find I’m smiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Some days really are")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("good enough to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I brush the breeze from my hair,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("pick the sand from my fingernails,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and watch as the last seven hours")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("swirl down the drain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Some days really do")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("leave their mark.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v("If Only Romeo Were Running Late "), _c('br'), _vm._v("\tto Her Funeral")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My desire for you has become palpable.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I dream we kiss, and I wake up aroused.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Wrong timing makes for")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("star-crossed lovers")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and lethal thoughts. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The tension has manifested itself in other ways.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Today, in the tearing of napkins and straw wrappers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("What will happen when the paper runs out?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I want you ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("turns into ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I need you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I shouldn’t")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" turns into")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v(" I can’t help myself.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v("Pressed Dandelions")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I keep weeds in a vase")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in my living room.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I feed them water.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I bathe them in sunlight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A child picked them for me,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("believing they were flowers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Who am I to tell him")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("not all pretty things")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("are worthy of saving,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("just as not all things")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("worth saving are pretty.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v("Dive")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have been daydreaming, treacherously.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You and I, we slow dance in this dream.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I do not dance; but with you,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I imagine it would be nice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Pressed together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Heartbeat to heartbeat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Palms and lifelines kissing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Swaying to words we cannot say")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but feel nonetheless.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v("Absent")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We aren’t here forever.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sometimes, the conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will come suddenly")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and arrive much too close")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to the beginning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We will feel robbed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We will be mad at time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Yet, no matter how fleeting,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I pray we can say,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("It wasn’t a long while,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("but it was worthwhile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("It wasn’t a long life,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("but it was a wonderful life.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Head-Centeredn t2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v("“I Am Sorry for Your Loss”")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When someone we love dies,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we say we ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("lost")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Perhaps this is our mind’s way")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of convincing our hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we will one day find them again.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v("Mellifluous Monotony ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The ice machine erupts,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("falling rocks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I smile at the sound of this routine from bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Every night")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you bring me a glass of water.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Even though you know, I never take a sip.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Even though you know, the condensation rings")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will be a bitch to wipe up come morning.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v("Obsequious")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I will stay")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I will not keep you         happy")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I will not keep you         faithful")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I will not keep you         here")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I will not keep you         long.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You will tell me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it is because I cannot be kept         happy")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("                                                                         faithful")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("                                                                      here")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("                                                                      long.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I will not keep you; but I will stay.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v("Broken Hearts & Brokenhearted People")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The first time my heart was broken,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I buried my mirror image with whom I shared a last"), _c('br'), _vm._v(" name and affinity for sushi and hot sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("She was broken, and brokenhearted people break people.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The second time my heart was broken")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was when I broke someone else’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I was broken, and brokenhearted people break people.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v("Traffic, Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I only ever noticed the wildflowers")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("growing along Interstate 84")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("when I was in the passenger seat of your car.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Bright orange and purple magic,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("granting wishes in the forced wind")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of the speeding cars.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("So vibrant.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("So hard to believe I never once")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("noticed them before.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I like to think you slowed my world down.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I like to think you opened my eyes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v("Basilicata")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It scares me,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("how young I will still be at my oldest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The weight of my mortality could kill me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as I sit in a 3,000-year-old city.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I curse the precarious nature of my existence.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I haven’t yet bathed in enough salt water,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("smelled enough of my mother’s cooking.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I haven’t woken up enough times")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with morning on my breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I haven’t gotten enough bee stings or paper cuts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I will never be ready to leave.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v("Check & Mate")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I see you seeing me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Not sure why you continue to stare.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I haven’t glanced in your general direction")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in quite some time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You keep competing, but")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that doesn’t mean you are winning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You see,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I stopped playing the game")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("once I realized I was being played, and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that sure as hell doesn’t feel like losing.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v("Day at Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sit curled up in an oversized, comfortable chair,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("reading a book that only made it to")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("New York Times")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Best Sellers’ list")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("because it was written by a dead girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The caramel wicker is smooth to the touch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The sun shines on the deck;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to my right, the endless Atlantic,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to my left, my beating heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wonder how I got here.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wonder when I became lucky enough")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to ask myself this question.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v("A Meteorological Phenomenon")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I saw a rainbow today.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I experienced a lot more,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("like a flat tire and a French kiss,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but the rainbow is what I wish to remember.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Though I know it’s merely a reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and dispersion of light, I imagine")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("what it would feel like to touch its bends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I close my eyes, reach,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and dip my hands into the colors like wet paint.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And for one brief moment,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am part of the iridescence.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _vm._v("Hard of Hearing")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me I will get over it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me I feel this way because I am young.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me I will laugh about it when I am older.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me I am overreacting.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me I deserve better.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me I am inexperienced and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that’s why I am distraught.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me I am being dramatic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me my eyes will clear.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me I will smile again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me how to heal—")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I didn’t hear you the first time.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _vm._v("The Send-Off & Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’s a fleeting romance found")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in the one-way ticket,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but there’s undeniable comfort")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in the round-trip.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Though I explore—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("collecting passport stamps,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hotel points and keycards,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tiny shampoo bottles,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and airline miles,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I cannot imagine never")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("looking back,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("never returning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I cannot fathom ever")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("losing sight of the familiar horizon of home.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _vm._v("Glimmers")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Even in the midst of my darkest days,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("there were minutes—moments—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("flickers")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" of light.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A smile through fear.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A pleasant dream stitched between")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the threads of a perpetual nightmare.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A sunny day that transiently warmed")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a heart that had been soaked by torrential rain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A restorative kiss that healed")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ten scraped knuckles and a battered mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("These small offerings of hope")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were all I needed to believe again")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("long enough to make it to the other side.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('div', {
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p34.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('p', {
    staticClass: "Ebook-TOC",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _vm._v("LP Track List")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer047"
    }
  }, [_c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor038"
    }
  }, [_vm._v("Sailing On")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor039"
    }
  }, [_vm._v("The Stains Left Behind")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor040"
    }
  }, [_vm._v("Leaf-Strewn Sidewalks")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor041"
    }
  }, [_vm._v("Dear God ")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor042"
    }
  }, [_vm._v("Motor Skills")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor043"
    }
  }, [_vm._v("This Isn’t About the Number Six")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor044"
    }
  }, [_vm._v("For You")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor045"
    }
  }, [_vm._v("2,000 Forecasts")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor046"
    }
  }, [_vm._v("Hiraeth")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor047"
    }
  }, [_vm._v("Nightmares & Daydreams "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ J.R. Rogue")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor048"
    }
  }, [_vm._v("Four Minutes in May")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor049"
    }
  }, [_vm._v("Hindsight & Pictures "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ Christopher Andrews")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor050"
    }
  }, [_vm._v("Gloves on Radiators")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor051"
    }
  }, [_vm._v("Detergent & Denial")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor052"
    }
  }, [_vm._v("Aunt Em"), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" (")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ Renee Mazza")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor053"
    }
  }, [_vm._v("Odylic Force")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor054"
    }
  }, [_vm._v("Springtime in the Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor055"
    }
  }, [_vm._v("You’re the Worst")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor056"
    }
  }, [_vm._v("Ten Little Girls (TW)")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor057"
    }
  }, [_vm._v("Transitions")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor058"
    }
  }, [_vm._v("It’s About Power")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor059"
    }
  }, [_vm._v("The Process of Apoptosis")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor060"
    }
  }, [_vm._v("Too "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ Caitlin Mahoney")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor061"
    }
  }, [_vm._v("Contrails")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor062"
    }
  }, [_vm._v("“All We See or Seem Is but a . . .” (TW)")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor063"
    }
  }, [_vm._v("Am I Doing This Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor064"
    }
  }, [_vm._v("Between the Notes "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ Highland Kites")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor065"
    }
  }, [_vm._v("The Beleaguered Ones")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor066"
    }
  }, [_vm._v("More Than Mere Limerence ")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor067"
    }
  }, [_vm._v("Saint Anthony")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor068"
    }
  }, [_vm._v("Original Christmas Song")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor069"
    }
  }, [_vm._v("Buried Alive")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor070"
    }
  }, [_vm._v("“. . . But the North Ward Is the North Ward”")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor071"
    }
  }, [_vm._v("Force of Forgetting "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ Taylor Belle")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor072"
    }
  }, [_vm._v("They Knocked Down the Gazebo")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor073"
    }
  }, [_vm._v("Vellichor & Venom")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor074"
    }
  }, [_vm._v("Ready, Set . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor075"
    }
  }, [_vm._v("Hope "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ Ada Pasternak")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor076"
    }
  }, [_vm._v("I Lose My Appetite Worrying If You’ve Eaten")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor077"
    }
  }, [_vm._v("Building Bomb Shelters")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor078"
    }
  }, [_vm._v("Guessing Genetics")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor079"
    }
  }, [_vm._v("Written October 2, 2017 (TW)")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor080"
    }
  }, [_vm._v("Bombilating Brains at Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor081"
    }
  }, [_vm._v("Twenty2")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor082"
    }
  }, [_vm._v("Sonder")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor083"
    }
  }, [_vm._v("Limelight Breakup")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor084"
    }
  }, [_vm._v("Save—Don’t Save—Cancel")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor085"
    }
  }, [_vm._v("Loose Threads Get Lost")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor086"
    }
  }, [_vm._v("My Fifth Sense")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor087"
    }
  }, [_vm._v("Everyone Else, Then Me")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor088"
    }
  }, [_vm._v("Ortley Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor089"
    }
  }, [_vm._v("Marie")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor090"
    }
  }, [_vm._v("Barnegat Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor091"
    }
  }, [_vm._v("Palermo")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor092"
    }
  }, [_vm._v("I’ll Take It (A Duet) "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ Codey Bearden & Arrie Bozeman")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor093"
    }
  }, [_vm._v("Apple Skin Stuck Between Teeth")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor094"
    }
  }, [_vm._v("More Cherry Blossoms Than D.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor095"
    }
  }, [_vm._v("EWR -> BCN")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor096"
    }
  }, [_vm._v("Counting Sirens")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor097"
    }
  }, [_vm._v("Told Myself "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ Carly Moffa")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor098"
    }
  }, [_vm._v("An Untrained Eye Will Miss Everything")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor099"
    }
  }, [_vm._v("70 in December "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/ Christina Hart")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor100"
    }
  }, [_vm._v("You Are Not the Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor101"
    }
  }, [_vm._v("A Clandestine Operation")])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor102"
    }
  }, [_vm._v("Footprints "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("w/")]), _c('span', {
    staticClass: "with-artist CharOverride-8"
  }), _c('span', {
    staticClass: "with-artist _idGenCharOverride-1"
  }, [_vm._v("Codey Bearden")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "Sub-TOC-"
  }, [_c('a', {
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#_idTextAnchor103"
    }
  }, [_vm._v("I Hope My Voice Doesn’t Skip")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer048"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _vm._v("Sailing On")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sing ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Anchors, aweigh!")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as I make my way")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from my old ways.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Though I fear less")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and less each day,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am still not quite fearless.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Seemingly")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bursting at the seams,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but this momentary might")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("might not")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("make me mighty.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To err is human, yes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I need fresh air")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to air my grievances.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Like how your apologies")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("need apologies.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Like how walking away")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was my biggest feat")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("since my feet stepped up")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and took their first steps.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Do not remain unfazed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("No, it is not ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("just a phase.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Speaking out")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("doesn’t make me outspoken,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it makes me heard")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("over the herd.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer050"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _vm._v("The Stains Left Behind")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You lose someone, and their ghost splatters everywhere. Black as squid ink in the fibers of your clothes. In the ringlets of your unwashed hair. In the last glass from which they drank. In the passenger seat of your car. The impression of their spoon in the sugar bowl matches your hollowness. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then life continues. The splatter fades. You wash your clothes and your hair. You clean the dirty dishes ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and refill the sugar bowl. Maybe you buy a new car or")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" move into a place whose entryway they have never danced through.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The sun still rises every day, the world still spins. You brush your teeth and replace the empty toilet paper roll. You walk your dogs. You set morning alarms  and hear new music.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Life pushes you along,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("routine keeps you breathing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Everything that they’ve touched with their hands, heart, or eyes is given away or pushed to the back of your mind and closet, or moved into the attic. Not on purpose. Not because you want to forget they existed here with you, but because you kept existing and you accept that though you cannot recall what their voice sounded like, you will never forget how they made you feel.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer051"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _vm._v("Leaf-Strewn Sidewalks")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The leaves still hold a glow, swirling and fluttering from the trees in Bryant Park. I try to remember, recall if the leaves are avoiding the inevitable longer than this time last year. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Perhaps the branches are the ones")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("that are refusing to let go this year.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I know what it is like to clutch on to something for as long as I can possibly stand, even when what I  wanted to keep was dead. I am constantly caught between being afraid I will always remember and being afraid I’ll forget one day. Not a unique thought or feeling, I am sure.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The sound of the wind funneling through these buildings reminds me of the ocean crashing, and for a moment, my two worlds collide; but I am in this  world now far more than the other. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Skylines and high-rises and busy streets have  replaced much of what I had known where I once found my feet. I wish when people asked me what I wanted to be when I grew up, I was smart enough to respond: ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("What’s the rush?")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _vm._v("Dear God ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lucid moments with her are")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fewer and far between.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She is, but I’m not,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("forgetting who she used to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("God tell me what to do")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("when you lose a person who")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is still standing in front of you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dear God,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("please don’t take her")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away from me;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("there is still so much in life ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("she has yet to see.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Like true love,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("nephews and nieces—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and things with time,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("like old-age creases.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dear God, please,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("allow her just one more turn")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to take back her life and learn")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that she is here for a reason—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that this cold weather")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is nothing but a passing season.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Show her clearer days")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("can be found ahead;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but none of this is possible,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if she is first found dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("God, you have shown me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the Devil lives in this powder;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and if you can’t hear my plea,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I promise to pray louder.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer054"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _vm._v("Motor Skills")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am losing track of myself again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can feel it in my restlessness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In the picking of my cuticles.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In the cracking of my knuckles.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In the playing with my hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In the wandering of my eye.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In my fatigue.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("“Something wicked")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("this way comes.")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-9"
  }, [_c('span', {
    attrs: {
      "id": "footnote-002-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#footnote-002"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve been drinking the same iced coffee all day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The dilution is off-putting but not deterring.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I release my hands from the steering wheel")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as I drive down the Garden State Parkway.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They ache terribly. I must have been gripping")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the wheel much tighter than I realized.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I make fists and then release,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("welcoming the feeling")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("returning to my fingers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I pay little attention to the mile markers")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as I make my way down the same highway")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve traveled countless times before.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Muscle memory will get me there.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left _idGenParaOverride-1 b"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It always has.")])]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-002"
    }
  }, [_c('p', {
    staticClass: "Footnote"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#footnote-002-backlink"
    }
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("From Act 4, Scene 1 of ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Macbeth ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("by William Shakespeare")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _vm._v("This Isn’t About the Number Six")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 weeks before you died, we sat together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You were sad, and I was mad,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but we managed to laugh and joke")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("about our crazy mothers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We ate sandwiches together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We hugged and we shared our last words.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Of course, we didn’t know then")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("they would be our last.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 seconds before I knew you were dead,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wasn’t thinking about you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was thinking about the test")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I had just sat down to take.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was on Shakespeare’s Sonnets.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Then my")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("          phone rang.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 seconds after I knew you were dead,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you were all I could think of;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I flipped through my memory,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tried to recall our last words.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I couldn’t remember, and I left class in tears.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 minutes after I knew you were dead,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my phone rang again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was my mother,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("frustrated with my father")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("for telling me about you")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("before I got home.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was already driving home.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My parents were nervous")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wouldn’t be able")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to concentrate on the road,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I made it home fine.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 hours after I knew you were dead,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I went on social media.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wrote, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I will miss eating french fries with you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I knew you would know what I meant.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("66 hours after you died, I saw you for the last time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Your father screamed my name. ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I still hear it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The lipstick you were wearing did not look right.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My mother whispered to someone to change it,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tand they did.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I read a prayer at your funeral.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can’t remember the name.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Your father eulogized you;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("his love for you kept his knees from buckling.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Your mother took a nap.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She woke up crying so loud")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we heard her from the first floor.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I saw my father cry for the first time")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as he hugged your father,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("who bought a suit he has not worn since.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I watched my father kiss your casket.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 days after you died, my mother turned 50.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She didn’t want to celebrate")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("her birthday that year,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tso we didn’t.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 weeks after you died, I ate an entire loaf of bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was with your mother and grandmother.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Your grandmother died shortly after,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I believe from a broken heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 months after you died, you turned 20.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I promised myself we would celebrate")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("your 21st the following year.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tWe did.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I found my journal;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you know the one.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I turned to the last page")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and found I had recorded our last words.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t l2"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("\tI’ll see you later, Cuz.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 Christmases after you died,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("your parents still hadn’t put up a tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I went to church,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("wanting to light a candle in your name.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Two times the candle wouldn’t light.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Very funny!")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I exclaimed to the ceiling. ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("To you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("On the third attempt, the candle sparked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tI smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("6 years after you died, I got married")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to someone you would have met if")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you had survived 6 months longer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You appeared in the slideshow, and your father")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("looked at me and mouthed, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Thank you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I still don’t know why he was thanking me;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wanted to see your face, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("600 weeks after you died,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am having dinner with your sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We discuss if losing you has made us stronger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I don’t want to be stronger, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("she tells me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I just want my sister back.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer059"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _vm._v("For You")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Everyone thought I was the strong one,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I wasn’t strong.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I broke out in hives. I slept two hours a night, only to "), _c('br')]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("wake up startled and out of breath, with my heart "), _c('br'), _vm._v(" beating so hard against my ribs that it was painful."), _c('br'), _vm._v(" I cried in the shower, I vomited, I fainted."), _c('br'), _vm._v(" I either ate nothing or binged.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("No, I wasn’t strong.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was an emotional mess who just kept it together,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("who remembered to breathe and smile")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in front of my parents.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The person who stayed when no light at the end of "), _c('br'), _vm._v(" the tunnel was in sight, who waited while "), _c('br'), _vm._v("I cried, itched, slept all day, or tossed and turned, "), _c('br'), _vm._v("made myself sick, didn’t shower for days, or used up"), _c('br'), _vm._v("  all the hot water, is the strong one in this story.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve learned you will always have to save yourself,"), _c('br'), _vm._v(" but it is easier to keep fighting with someone in your"), _c('br'), _vm._v(" corner.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer060"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _vm._v("2,000 Forecasts")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Reading by candlelight,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it was cold that October night.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Drunk off six-dollar wine,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the hurricane raging outside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That night we slept wrapped in quilts,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("talking about our neighborhood")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and what had to be rebuilt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I couldn’t see through the blackness")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that night on your mattress,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I felt your telltale heart,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it promised us a fresh start.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("2,000 forecasts have passed")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("since you last smiled and asked")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("me what we’d name our children.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The memory plays the first crisp day")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and my heart always gives way,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("relives us when the leaves descend.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We survived the storm but not the fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We survived the storm but not the fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("After two nights of freezing,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("kissing noses running, sneezing;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("after a roller-coaster drowning,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("80-mile-per-hour winds howling,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the house buzzed again with power."), _c('br'), _vm._v("You celebrated in your boxers"), _c('br'), _vm._v("and I joined you in the shower.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Empty glasses left in the sink,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("your ice eyes and that wink.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The heat was rising, you held me near;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you sang The Turtles in my ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("2,000 forecasts have passed")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("since you last smiled and asked")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("me what we’d name our children.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The memory plays the first crisp day")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and my heart always gives way,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("relives us when the leaves descend.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We survived the storm but not the fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We survived the storm but not the fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wore your shirt to bed those days.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I still have it, the sleeves have frayed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I surely would have froze to death")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if I didn’t know you or share your breath")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("for that one brief, long moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But we survived the storm,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("not the fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We were the storm")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and we’re better off.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer062"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _vm._v("Hiraeth")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Yesterday I cooked bacon because the smell reminds me of my father and Saturday mornings in that old ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("house on Valley Street across from the railroad tracks. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Back when we had one television that took twenty minutes to turn on. Back when I shared a bedroom with both of my siblings. Back when that Billy Joel cassette melted in the tape deck of my mother’s light-blue Thunderbird.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Back when we searched for goldfish in the stone pond")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" my father unearthed in the backyard on my little ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("brother’s birthday. Back when the aroma of citronella ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("torches was synonymous with summer. Back when our grandfather was still alive and brought us  doughnuts in a white box tied with a candy cane-striped ribbon. Back when my mother used to sing “Que Sera, Sera” to my sister every evening before  our good-night prayer. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That old two-family house, with white siding, where we used to play on the front porch and pluck thorns ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from my parents’ rosebushes. Where the Christmas ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tree fell down one year in the middle of the night. Where we used to yank up oniongrass just to  smell it, and where we touched our tongues to  honeysuckle flowers. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("As the bacon tap-danced in the skillet, I imagined mail was being delivered to the house I still  occasionally drive past. Though I may never walk up  those cracked stone steps again, or hear the swing of that particular kitchen door, there’s a deep security felt when a simple scent floods me with memories that only a handful of people I love could recognize.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer064"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _vm._v("Nightmares & Daydreams")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Featuring J.R. Rogue (")]), _c('a', {
    attrs: {
      "href": "http://www.jrrogue.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("www.jrrogue.com")])]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have nightmares;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I’m not talking about")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the kind that grab you with")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("their ebony grip while")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the rest of the street slumbers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have daydreams;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I’m not talking about")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the kind that seduce my")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("smile out of hiding")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and color me senseless.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have scars;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I’m not talking about")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the two on my stomach")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from when I was on dialysis")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("or the one on my finger from when")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was doing cartwheels and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("landed on a broken glass bottle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have imperfections;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I’m not talking about")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the chip in my left tooth")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("or my crazy hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have faith;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I’m not talking about")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the intangible kind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m talking about the breathing soul asleep")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on the pillow next to mine.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer065"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _vm._v("Four Minutes in May")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("12:07 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The wind chimes get swept up in the ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("not-quite-yet-")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("summer ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("breeze along with the ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("not-quite-dry ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shirts on")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" the clothesline.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The sun breaks through the clouds, offering the promise of a wonderful day. I breathe in the first few hints of my second-favorite season.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("12:09 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The telephone rings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("12:11 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I remain in the lounge chair, suddenly angry at the breeze for blowing life into clothes you will never wear again.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer066"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/GettyImages-104633675_jb_left.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame l2",
    attrs: {
      "id": "_idContainer067"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Leftn ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _vm._v("Hindsight & Pictures")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Featuring Christopher Andrews")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You and I, nothing but a mess.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dressed")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("like the best")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("love story that ever was;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but we were")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a fatal mixture,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("just pretty ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in hindsight and pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You and I, a flawed design.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lines")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("blurred between")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the pleasure and so much pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("So save me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("all of your lectures,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we’re only real")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in hindsight and pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You and I, in such distress.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Nonetheless,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we soaked in")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the glory and the applause.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Gettin’ off,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("gettin’ sicker, while that")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("grapevine whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Oh, hindsight and pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You and I, I left behind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Unsatisfied,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with the monsters")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we became, so I severed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Cut the tether")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to that fatal mixture")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘cause we’re only livin’")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in hindsight and pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hindsight and pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A fatal mixture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hindsight and pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Save me the lecture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hindsight and pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Grapevine whispers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hindsight and pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A fatal mixture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hindsight and pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Listen to “Hindsight & Pictures”:")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-1"
  }, [_c('br')]), _c('a', {
    attrs: {
      "href": "http://www.thealiciacook.com/chrisandrews",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("www.thealiciacook.com/chrisandrews")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer069"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _vm._v("Gloves on Radiators")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It is one of those days when it is so cold everything takes on a frosty-blue hue. I take a dangerously deep breath, and my throat stings. Water would soothe  it, but it is all frozen. Kids pretend they are smoking cigarettes each time they exhale, and noses, drainpipes, and windowsills collectively weep all around. Their sadness is loud.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Plop. Plop. Plop. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The sound reminds me of my mother")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("dropping ice cubes into our soups.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Does it hurt to melt?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I imagine they cry because they miss the warmth of ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the sun and freckled noses and blooming pots on ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ledges. It is one of those days where I make pancakes ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" and poached eggs because that’s what we’ve always done when winter makes itself known.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The first thing I ever told the first person I fell in love")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" with was that I hated snow. One lifetime later and I still stand by that statement even though I no longer stand by that man.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I count forward on my calendar, to the first day of spring.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("One, two, three")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Where my pointer finger lands is where I find relief.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer070"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _vm._v("Detergent & Denial")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sit on my laundry room floor just watching the dryer spin my clothes around and around.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Da thump.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Da thump.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Da thump.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("If I get up")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and go upstairs,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I need to say it aloud.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Saying it aloud will make it real.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m not ready to make it real yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("If I stay here instead,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("only the spider webbing in the corner")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I will know what we know.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I remain on my laundry room floor, phone in hand, heart beating in my chest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Da thump.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Da thump.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Da thump.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Machines and humans share similar sounds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They break the same, too.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer071"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/GettyImages-104633675_jb_left.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame l2",
    attrs: {
      "id": "_idContainer072"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Leftn ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _vm._v("Aunt Em")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Featuring Renee Mazza")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Oh, Dorothy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("please open your eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Silence cuts like knives.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You’ve been gone for days.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Our world has gone gray")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("without your smile here.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Oh, Dorothy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dear, are you awake ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in some far-off place? ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Your eyelids shudder, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("can’t help but wonder ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if your dreams bring fear. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I hope your brain never scatters,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("your heart never shatters,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and the courage you gather")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("brings you back to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("May the wicked witches never hurt you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("May you meet friends who support you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("May a bright-yellow road return you")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("back to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Oh, Dorothy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my eyes haven’t slept,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but oh how they’ve wept.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The hourglass sand ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("holds the upper hand ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as we sit beside your bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Oh, Dorothy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the tornado destroyed, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("created this void.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You’re missing it all;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("like the simple songs ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from birds overhead. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I hope your bright brain never aches,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("your heavy heart never breaks, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and your courage shapes")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("your path back to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("May the air from a hot balloon ride you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("May three clicks of your heels glide you. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("May the glow from a rainbow guide you ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("back to me. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Oh, Dorothy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("return from where you roam. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Trust me when I tell you:")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("There’s no place like home. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Listen to “Aunt Em”: ")]), _c('a', {
    attrs: {
      "href": "http://www.thealiciacook.com/reneemazza",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("www.thealiciacook.com/reneemazza")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer074"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _vm._v("Odylic Force")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You tell me as long as I don’t smile at you,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you can stay composed, and my face flushes. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You warm me when you sneak up behind me,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("nudging my lower back, and I imagine what your weight would feel like on top of my body.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I tell you I enjoy being around you and ask how your day is going, but what I really want to know is")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Do you ever dream of me?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Because I dream of you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In the most vivid of colors.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In the most dangerous of ways.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I tell you that I like how your socks match your tie and ask how your weekend was,")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but what I really want to know is")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("What happens to your body when I walk into a room?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Because when we are in shared space,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so much fresh air enters my lungs,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("they feel new.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The day starts over.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You reset me and have no idea. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I think your eyes sparkle")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("when they meet mine,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but it could just be a cruel trick of light.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer075"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _vm._v("Springtime in the Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am a child, holding my great-grandmother’s hand")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as we weave between the tombstones.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I free myself and begin walking very close to the graves of long-gone strangers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Do not walk directly on top of them,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" she warns.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Do not disrespect the dead like that.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("II.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Three years later, I am seated in that very same  cemetery, at my great-grandmother’s funeral; a dog barks in the distance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My siblings play hide-and-seek behind")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the stones and trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Do not disrespect the dead like that,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I repeat to them,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("not sure at the time what that means.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("III.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Many years later, a toddler holds my hand")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as we follow a funeral procession to the tent.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Where are we? ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("he asks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("We are at a park,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I lie, because a lie is easier than  explaining death.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("But people don’t cry in parks,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" he says back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("IV.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My parents learn the cemetery is developing new  land and decide now is the time to purchase their plots.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They buy a few extra in case my husband and I ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("decide we want to rest there, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("V. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My father returns with graveyard dirt under his nails.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He tells me it is not really Easter until you visit your dead.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer077"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _vm._v("You’re the Worst\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was carrying the weight of your abandonment")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and it callused my hands,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("broke my spirit,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("froze my heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I let go,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out of necessity,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and learned you")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were the worst thing")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to ever happen to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I know this because")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("once the pain faded,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you faded.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Entirely. Gone. ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Poof.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("If you were anything more than")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("just plain old hurt,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you would still live in my memory,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("still find yourself nestled comfortably")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in even the smallest nook of my heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You were pain,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I don’t hold on to pain anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I let go.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("If you were the worst")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to ever happen to me,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the best is yet to come.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer078"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _vm._v("Ten Little Girls (TW)")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Modeled after the nursery rhyme “Ten Little Indians”")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ten little girls get bullied online;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one hangs herself,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so now, there’s nine.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Nine little girls restrict food intake;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one destroys her kidneys,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so now, there’s eight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eight little girls all turn 11;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("an uncle touches one,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so now, there’s seven.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Seven little girls touch food to their lips;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one develops bulimia,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so now, there’s six.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Six little girls go for a drive;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one is texting and steering,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so now, there’s five.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Five little girls sneak in a drawer;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a gun accidentally goes off,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so now, there’s four.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Four little girls lose their virginities;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one gets pregnant,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so now, there’s three.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Three little girls take a pill that’s blue;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one quickly overdoses,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so now, there’s two.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Two little girls just want to have fun;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one gets kidnapped,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so now, there’s one.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("One little girl remains out of 10;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("there’s got to be one success story"), _c('br'), _vm._v("every now and then.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer080"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _vm._v("Transitions")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I smell rain")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The world outside is too loud today.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Car horns and leaves scratching on the pavement")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("like city tumbleweeds wake up my anxiety.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("People yell in a language I can’t understand,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but by the tone, I can tell they’re angry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Everyone seems so angry lately.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The early November air plays perfectly")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with my hair and blows life into my lungs")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but somehow manages to miss my heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Clouds roll in and, in the distance,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the rumble of thunder erupts and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a car alarm goes off in response.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("More noise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sacrifice the breeze and close the windows")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on all four of my heart’s hammering chambers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This world sure is beautiful")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("without all the noise we make.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The falling rain splits the afternoon open,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("allowing room for self-reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in the middle of this loud day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Another autumn leaf floats")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("to the ground somewhere,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I can feel it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Five minutes of quiet is all I need to regroup.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I gather my breaths and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("roll down my windows once again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I take a deep lungful of ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("this beautiful, rarefied air,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("full of life and sound and emotion,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that even the grateful")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("take for granted")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from time to time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I smell resurgence.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer082"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _vm._v("It’s About Power")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You were ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("almost always")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("One arm in the sleeve of your jacket.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("One foot out the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The selfish fluidity was paralyzing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Were you fifteen minutes late or")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("already fifteen miles closer to your next life?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It took a long time to realize I gave you that power.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The power to leave.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The power to come back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The power to be in two places at once.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sometimes prying your power back from the hands of someone accustomed to abusing your love means ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("breaking your heart one last time. Hurting to heal will  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("be painful at first, but nowhere near the agony of hurting to stay.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer083"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _vm._v("The Process of Apoptosis")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There is no comfort in change. It is foreign and  prickly; fiberglass on your arms, ice on your back molars, that hard bite of Jell-O. Change stretches our bones and minds to uncomfortable lengths without warning and then expects us to grow into it quickly. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There is no peace in losing someone. It is disruptive.  It is heartbreaking and disharmonious; nails on a chalkboard, a fork scraping on a plate. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There is no beauty in pain. We imagine there to be, though. The beauty born from pain is man-made,  created by the writers and the dreamers who  romanticize recollections. Pain is ugly. No one should long for pain. No one should chase after pain. When pain does find you, you won’t see any beauty—just blackness. Don’t you ever forget it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The comfort and peace and beauty are found in the reclaiming of your life in spite of it all. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer084"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/GettyImages-104633675_jb_left.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame l2",
    attrs: {
      "id": "_idContainer085"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Leftn ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _vm._v("Too")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Featuring Caitlin Mahoney")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It’s the feeling we’ve met before, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("somewhere in our other lives,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and we’ve been brought back to this one ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("through space and time, and by design. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("None of this feels ordinary. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You are my very first d")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("é")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("j")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("à")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" vu.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Do you feel it, too? ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me you feel it, too. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That the hazel flecks in your eyes ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("recognize my royal blue.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me you feel it, too. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve tasted your tongue, memorized ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the songs our sighs sing as we rest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I swear my hair already knows ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the bliss of sleeping on your chest. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We are lightning and striking twice. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You are my familiar brand-new. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Do you feel it, too? ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me you feel it, too. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That we’ve both been uninspired, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tired, waitin’ on a breakthrough.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me you feel it, too. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My palms miss your hands and long to ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hold them in this reality. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The years are long, and I’m not sure ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("how I survived the first thirty. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My eyelids have kissed your lips. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You’re Christmas on Park Avenue. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Do you feel it, too? ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me you feel it, too. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That you spent years digging up lies ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to unearth this one epic truth. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me you feel it, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That you spent your whole life running")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and standing still is overdue.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tell me you feel it, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Listen to “Too”: "), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.thealiciacook.com/caitlinmahoney",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("www.thealiciacook.com/caitlinmahoney")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer087"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _vm._v("Contrails")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Today the sky is so pretty, I imagine Heaven is  hanging a little lower to keep a closer eye on us for the day. A fellow golden hour admirer pulls out her ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("phone and snaps a few images, whispering to herself,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("It’s like Heaven on Earth.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The phrase stuck with me the rest of the day. ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Heaven on Earth")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". I hadn’t heard it in a while. I hadn’t heard it since I lost you, actually. I imagined what it would be like if Heaven could really pay us a visit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We’d be able to walk side by side with people we love who we lost, and never forget the sound of their voice or their scent.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We would never know the pain that goes hand in hand with our impermanence here on the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Simply put, it would be amazing.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer088"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _vm._v("“All We See or Seem Is but a . . .”")]), _c('span', {
    staticClass: "CharOverride-12"
  }, [_c('span', {
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#footnote-001"
    }
  }, [_vm._v("2")])])]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" (TW)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To the observer,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my life has begun to orbit around")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("black-tie weddings, vacations, successes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and bottomless brunches.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In reality,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my life revolves around")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the marriages and divorces of my friends,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("their pregnancies and miscarriages,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("becoming parents and losing parents,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the overachieving of some and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the overdoses of others,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("strands of our hair turning gray or")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("losing it all to chemo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("As I stand on this rooftop bar,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("surrounded by café lights and muddled drinks,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ll nurse this one glass of Chardonnay")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and clutch these condensation-soaked napkins")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve been holding on to all night,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I’ll pay for a cab ride home")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("even though I could just drive myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Some days, it is simply easier to pretend")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we are all as fortunate and as beautiful")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as their general presuppositions.")])]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-001"
    }
  }, [_c('p', {
    staticClass: "Footnote"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#footnote-001-backlink"
    }
  }, [_vm._v("2")])]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" From the poem “A Dream Within a Dream” by Edgar Allan Poe")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer089"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _vm._v("Am I Doing This Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A woman I know told me her wedding song came on while her husband was away for business and she cried in the shower. Another woman I know told me she gave up her career to move across the country  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with her fiancé so he could pursue his lifelong dream.")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("  Another told me they plan on having three kids and buying a house on a cul-de-sac. She used the term  ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("forever home,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" and for some reason, it made me feel sick. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Another told me she preserved her wedding dress in a shadow box and just stares at it some lazy Sundays. A young girl I know told me she spends most of class time scribbling her and her beloved’s initials in her notebook. I don’t have the heart to tell her that her first love will also be her first heartbreak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I know I love you, but I feel like I am doing it wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t cry when you are away, and I would have to think long and hard before I gave up my goals in exchange for yours. Three kids are two too many. I bought the first wedding dress I tried on, and since we exchanged vows, it’s been at the bottom of a hamper, slowly turning yellow. I never scribbled your name anywhere. I began a scrapbook of us years ago and abandoned the project the very same day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have never been below average in anything I  pursued, but looking at the love stories of others, I feel as though I fall short of giving you all you  deserve. I might not be capable.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then, my mind calmed when, in the quiet of the home we created, I found myself picking up your purple sweatshirt and breathing in deep because I missed your scent. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I know I love you, and you know, too.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer091"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/GettyImages-104633675_jb_left.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame l2",
    attrs: {
      "id": "_idContainer092"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Leftn ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _vm._v("Between the Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Featuring Highland Kites")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I visit our spot every once in a while.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hear melodies of reconcile. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sway between the notes and the Lilies of the Nile,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I remember when we danced in time,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but our music has ceased. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I trace our initials in the dock’s creases. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A lifetime has passed since we")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("carved those masterpieces.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You and I,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You and I are unsolved dissonance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Our chorus, our chords took on a bitterness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Our love, our hate faded to indifference.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My body, it shakes, as I try to make sense of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I try to make sense of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Our hearts now beat at different tempos.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m giving up, giving in, letting go.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t wish back the time we borrowed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I will remember when you were mine,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("when the summer sun glows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It’s been a long ride, but I need you to know")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("despite what was lost in the fall,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we had something beautiful.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You and I,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You and I are unsolved dissonance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Our chorus, our chords took on a bitterness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Our love, our hate faded to indifference.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My body, it shakes, as I try to make sense of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I try to make sense of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I walk to our dock,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cold water on my feet")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I know you’ve already")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("forgotten me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sit at our dock, the water lapping.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t think of you much at all these days ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But I hope you are somewhere, happy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Listen to “Between the Notes”: "), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.thealiciacook.com/highlandkites",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("www.thealiciacook.com/highlandkites")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer094"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _vm._v("The Beleaguered Ones")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am at war with choices I didn’t make but have to  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("live with nonetheless. I understand it’s a counterstrike ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("battle because the attacker was not aiming at me, but I’ve been hit. It’s impossible to dodge stray bullets because you never see them coming, do you? The  impact might not always be fatal, but the impact ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("always hurts. ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The gravel in my throat and eyes, it hurts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve been grazed and hit precisely by life’s blows because someone I love was targeted. Someone I love ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was the mark, but I am left wounded in the street. The ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" collateral damage in all of this gets to die alongside the ones we love, but we die and our ghosts are left here to clean up messes and pick out coffins.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Our burial sites are shallow graves; dressed as  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("twisted receiving lines where ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I am sorry for your loss")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" is repeated in our faces every two seconds. I read once ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that it was rumored the Catholic Church was doing away with Purgatory, what some call Limbo, and I am starting to think that is because our lives become ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Purgatory when we lose someone we love.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer095"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _vm._v("More Than Mere Limerence ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I didn’t fall for you on purpose,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but it’s never really on purpose I suppose.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It all happens slowly, doesn’t it?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Between coffees and drinks and shared glances.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It sneaks up on you")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" . . .")]), _c('span', {
    staticClass: "CharOverride-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t ParaOverride-6"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("the")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-6"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("fall")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-6"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("ing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They get under your skin. Your knees nudge and  your fingers linger as you pretend to argue over who’s going to pick up the check. You become more ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("curious so you ask more questions and suddenly you")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("find yourself waking up easier on days you know you")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" are going to see each other. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then they begin to appear in your dreams, and you ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("start to wonder what they do for fun or how they look")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" naked. It is exciting and terrifying. You battle  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("between shaking them off or giving in, grabbing their ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" face, and kissing them just to see what their mouth tastes like.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer096"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _vm._v("Saint Anthony")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When I was a child, I wore my favorite gold bracelet every day. One day I looked down to find it was no ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("longer there. My stomach dropped and I began to cry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Where did you see it last?")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" my mother asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The beach, maybe. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I couldn’t recall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Pray to Saint Anthony,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" she suggested.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I must have repeated the prayer twenty times as my mother and I scoured the sand with flashlights. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Dear Saint Anthony / Please come down /")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("There is something lost / That needs to be found.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Dear Saint Anthony / Please come down /")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("There is something lost / That needs to be found.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Dear Saint Anthony / Please come down/")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("There is something lost / That needs to be found.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I tapped into my heart, into my faith, and truly prayed for Saint Anthony to return my bracelet. And the jewelry turned up and returned to its home upon my wrist.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("As I’ve grown and begun to experience the loss of things more precious to me than that bangle, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("like people,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("like you")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I apply the same practice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Dear Saint Anthony / Please come down /")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("There is something lost / That needs to be found.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I search my heart, and I find you there every time.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer098"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _vm._v("Original Christmas Song")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My father still strings twinkling")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("white lights for me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("across that timeworn tree")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("outside my old bedroom")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I visit only occasionally.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A grown family of five")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("arrive home separately now.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("No longer are there early")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("mornings spent in nightgowns.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The winter’s been colder,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we’re getting older,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I feel Christmas moving further")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from what it used to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But Mom still decorates the tree,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("while Bing and Danny Kaye sing,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I am with my family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This is what Christmas means to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Have Yourself a Merry Little Christmas” plays.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Nostalgia, in waves,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as I remember days")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as though it were yesterday")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("when all of our stockings hung in one place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ll never take the magic")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("for granted ever again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ll remember this wonderland")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and what it all meant.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The winter’s been colder,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we’re getting older,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I feel Christmas moving further")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from what it used to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But there’s still record player static")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and wrapping paper havoc,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("taking trains down from the attic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This is what Christmas means to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The smell of pine,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sparkling wine.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Italian tradition,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("feast of the seven fishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Velvet dresses,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Mom cleaning up messes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The smell of peppermint,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("snowy footprints.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("No school for a week,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("kisses on cheeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Everyone’s gleeful,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("singing at the Cathedral.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tree trimming,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dad always filming.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Cousins playing games,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Grandpa misspelling my name.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Cold weather,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and a family, together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This is what Christmas means to me.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer100"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _vm._v("Buried Alive")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have started over many times, but repetition does not make anything easier. The pain is in the details, in the shadows and crosshatching of our smiles and frowns.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am not going to lie and tell you starting over was easy. It was so hard. Most will lie and tell you it was ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the easiest decision they ever made. I am not sure that ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("they lie purposefully. I think once we start over, we forget how hard it was to shed our skin. Painful, even, to outgrow our own bones. Even when starting over ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is a choice and not a force of your hand, it still may be ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the hardest thing. We just forget how difficult it really ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was, because sometimes the hardest thing is also the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" best thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I will not lie and tell you that you will not cry, even when you make the best decision for yourself. I have mourned myself. I have grieved. Few hold an  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("appreciation of life that only comes from being on the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("brink of death. That only comes from having to claw your way out of your own grave.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer101"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  }), _vm._v("“. . . But the North Ward Is the North Ward”")]), _c('span', {
    staticClass: "CharOverride-12"
  }, [_c('span', {
    attrs: {
      "id": "footnote-000-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#footnote-000"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There were seven shootings in my city last night. The ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("news didn’t go national because only one of the seven")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" shootings proved fatal. I happen to know in that very ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("same city, that very same day, a child learned how to ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ride a bike. A family barbecued. A young woman  blew out her thirtieth-birthday candles.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("II.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My neighbor’s home was broken into twice in one week. It is what it is. I put the security camera sign back up and measured my basement windows for wrought iron bars. I’ve since heard more laughter,  ice cream truck music, and dogs barking than sirens.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("III.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I pick up my friend from the airport. Once we get on")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" McCarter Highway, the traffic slows because the  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Devils’ game is just letting out. This provides those on the street the opportunity to approach cars to ask for")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" money. They move slowly, Styrofoam cups in shaky ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hands. In six minutes, three women approach my car.")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" My friend’s mouth drops open.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Holy shit, these girls look just like us, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("she says.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A shift that may shock those who don’t see what I see on a daily basis.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Direct result of the opioid crisis")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", I guess back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("IV.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am introduced to my friend’s new boyfriend. He  asks where I live, and when I tell him, he visibly  winces.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I could never live there")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", he judges. ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Even if they are calling")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v(" it ”the next Brooklyn.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I just laugh and tell him it may not be for everybody.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("What I really want to ask him is if he knows his  mailman by name, or if his neighbors pull in his  garbage cans when he isn’t home. I wonder if the  people on his block know his parents and  grandparents. Do his neighbors spend time shoveling one another’s walkways when it snows or help the elderly woman on the block with her groceries? I  want to ask him if the bakery in his town calls him personally on Easter or on random Sundays to see if it needs to save special bread for him and his family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In historic cities like mine, neighborhoods like this still exist, but that never makes the news.")])])]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-000"
    }
  }, [_c('p', {
    staticClass: "Footnote"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/VoiceDoesntSkip_mobi_epub#footnote-000-backlink"
    }
  }, [_vm._v("3")])]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" A line of dialogue from ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The Sopranos’")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" episode “")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-1"
  }, [_vm._v("Johnny Cakes”")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("(Season 6)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer103"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/GettyImages-104633675_jb_left.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame l2",
    attrs: {
      "id": "_idContainer104"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Leftn"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _vm._v("Force of Forgetting"), _c('br')]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-13"
  }, [_vm._v("Featuring Taylor Belle")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sunlight creeps in with blackness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Days of dust and shattered glass ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("have contorted the face")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I once could see")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in the frames on my dresser.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("At the foot of the mattress,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my broken heart holds mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When God and I touch base,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He tells me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you’re just settlin’ for lesser.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ll miss you longer")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("than you ever would’ve stayed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That’s what writers do,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("how we make it through")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("being betrayed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("These sheets remember you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The pillows")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and the floorboards, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("These sheets remember you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The pens")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and the ink stains, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This is the force of forgetting you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You disremember with ease,"), _c('br'), _vm._v("but you still conquer my thoughts. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I cannot scream anymore"), _c('br'), _vm._v("at your tone-deaf heart; "), _c('br'), _vm._v("it all hurts too damn much.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I write it down to free "), _c('br'), _vm._v("and relieve my stomach knots.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The words pour and pour and pour"), _c('br'), _vm._v("out, and I fall apart")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as my paper and tears make love.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You’ll remain in my words")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("longer than you did my bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You won’t ever change,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and so you became")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fodder instead.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("These sheets remember you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The pillows")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and the floorboards, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("These sheets remember you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The pens")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and the ink stains, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This is the force of forgetting you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This is the force of forgetting you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1 _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Listen to “Force of Forgetting”: "), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.thealiciacook.com/taylorbelle",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("www.thealiciacook.com/taylorbelle")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer106"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _vm._v("They Knocked Down the Gazebo")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Snow smothers most of the noise,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but not the howling of the wind or")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the roaring of the ocean.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Everything else is quiet though,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("even my mind. For once.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("When was the last time I heard the gasp of each breath?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I take it all in because")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t think I’ll be back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve outgrown this town.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can no longer button up the familiar air.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can no longer slip the beach blocks over my head.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The streetlights and stop signs come up short, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("shrunken")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("For today though,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I squeeze myself into Third Avenue")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("one")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("last")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("time")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("because at one point not only was this the only place that fit, it was the only place I knew, and it’s hard to say goodbye.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("No matter what,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it is always hard to say goodbye.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer107"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _vm._v("Vellichor & Venom")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am standing in front of the limited self-help section of a bookstore in the Hamptons.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("An associate walks up to me and asks, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Do you know what you are looking for?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She seems a bit too curious, too eager; like she has too")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" often seen seemingly put-together people with full bank accounts and pretty eyes stroll in from off the street and expose their demons in front of these same shelves.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her delivery is too pointed, as if she were wondering, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("What’s wrong with this one? Eating disorder? Daddy issues? Prescription pill addiction?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" As we stand there, of course I know what I am  looking for in the Goddamn self-help section. Help. For myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I stare blankly for a moment and blink hard twice  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("before responding, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Do you have anything on what to do ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("once you fail as a wife, cousin, sister, and human being in general?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her lips part and she mumbles something about a book like that not being on the shelf. She must be used to flaws staying beneath one’s skin, where many believe they belong. My honesty does not sit well on her petite shoulders.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I finish the conversation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Well, there’s a market for it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("With that, the spineless woman leaves me to peruse the book spines on my own, as I intended. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer109"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _vm._v("Ready, Set . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Start running after yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The person you yearn to become")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will never slow down for you,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will never wait for you to")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("collect")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("your")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("courage.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The person you want to leave behind")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will do everything in its power to keep you")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from catching up to your own potential.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Though that voice cannot be silenced,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it can be passed")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and no one hates being outpaced more")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("than the person you used to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The person always")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so used to seeing you a")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("few")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("paces")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("behind.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer110"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/GettyImages-104633675_jb_left.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame l2",
    attrs: {
      "id": "_idContainer111"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Leftn ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _vm._v("Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Featuring Ada Pasternak")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Been down and out,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("filled with doubt,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("had this little heart of mine")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("kicked around.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("All of this hurt")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("won’t break my soft.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("What is gone")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is never lost.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’s still hope in this hook,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("belief in the bridge,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that all of these scars")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("are proof that I lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’s still hope in this hook,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("belief that tomorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will hold a silver lining")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to all of this sorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("On the sunniest day,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the sky can seem gray,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but all of my warmth")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("can’t be taken away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("All of these battles,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("they’ve made me fierce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Know that my faith")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cannot be pierced.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’s still hope in this hook,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("belief in the bridge,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that all of these scars")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("are proof that I lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’s still hope in this hook,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("belief that tomorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will hold a silver lining")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to all of this sorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’Cause crying doesn’t make me weak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It’s my soul, just trying to speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Oh, I don’t want to go to sleep,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("knowing that I could’ve done better than this.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("(Knowing that I could’ve done better than this.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’s still hope in this hook,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("belief in the bridge,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that all of these scars")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("are proof that I lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’s still hope in this hook,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("belief that tomorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will hold a silver lining")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to all of this sorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’Cause crying doesn’t make me weak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This is my heart just trying to speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Listen to “Hope”: ")]), _c('a', {
    attrs: {
      "href": "http://www.thealiciacook.com/adapasternak",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("www.thealiciacook.com/adapasternak")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer113"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _vm._v("I Lose My Appetite Worrying If You’ve Eaten")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("You need to stop internalizing other people’s pain,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" my mother tells me on the phone. ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("It’s not healthy.")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" She is ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("right; I have done this all of my life. Like an overused sponge, I soak up all the sadness around me, feel it as ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if it were my own, and expect it not to seep into my own life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Don’t be blinded by your own light, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("she cautions.")]), _vm._v(" "), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("And don’t get hurt by pain that doesn’t belong to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But if I’m not pained by their pain, I have not earned the right to be overjoyed by their joy.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer114"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  }), _vm._v("Building Bomb Shelters")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We build walls in order to keep people out,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to protect ourselves from pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I do not believe these walls are constructed")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with bricks and cement")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but with ivy and vines and branches")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that grow freely around us,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fertilized by the ache.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We lay the foundation for these walls,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we continue to water the hurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Stop watering.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Stop spending time with rain clouds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Instead, wear the sun on your face.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The walls will crumble,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("gates and doors and windows")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will take shape,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and you will be able")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to begin to ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("let the light in.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer115"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  }), _vm._v("Guessing Genetics")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("His raven hair and my blue eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It is brought to our attention regularly. A dreamy vision paired with pressure. His raven hair and my ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("blue eyes. Surface stuff that paints a pretty, nuclear  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("picture. While they pair his dominant with my  recessive genes, all I could think of is his  indecisiveness with my selfishness. His neat-freak tendencies with my manic behavior. His soft-spoken nature with my short temper. His first-responder training and my habit of never wearing my seat belt. His light with my dark. My light with his dark. I find ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("myself thanking God that my genes are the recessive")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" ones because he possesses more good in his pinky finger than I do in my whole body.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But yes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("his raven hair")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with my blue eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("would be beautiful. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer116"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  }), _vm._v("Written October 2, 2017 (TW)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I woke up to the profound sound")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of a world smothered silent.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The sun shone through the curtains.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It would have been a beautiful day,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m certain,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if it weren’t colored by violence.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("People running for their lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t shield my eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m so desensitized")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I’m mad at myself for that.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve been watching wars")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on my TV screen")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ever since I was fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I’m mad at the world for that.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A shadow cast,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("flags at half-mast,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("knowing this won’t be the last")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("time I’ll be afraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They say love makes")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the world go ’round,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but the ones with love in their hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("are the ones gunned down.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("What do we gain from all of this pain?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Most just post prayers online.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It’s hard to feel safe at all")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("when someone gets twenty-one guns")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("down a hall")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with plans to traumatize.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Earth can’t keep us safe;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it’s not its role, not its place")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to lead us to better days.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Only we can guide each other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Too many innocents slain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A date forever bloodstained.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Our faith in humanity strains.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Only we can save each other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Collective sighs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("No reason why")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("all these people have to die")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from a horror so stark.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They say light shall")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("conquer the dark,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but every time terror strikes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we lose a bit of our spark.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We must trust")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("there are less of them")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and more of us")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in this world.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer118"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  }), _vm._v("Bombilating Brains at Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Can you please speak up? I am having trouble  hearing you. The flies on the walls of my mind are contributing their two cents again, rather loudly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left ParaOverride-8 t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Buzzzzz – I’d like to see you turn this mess into poetry – buzzzzz.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I shake my head and my thoughts fall back into place and I am able to focus on you once more. I quickly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("catch up to the conversation you think we are having.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My mother says I did the same thing in school. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Teachers complained to her regularly that I zoned out ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in class; but when they tried to catch me lost in the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("lesson, I’d come back to reality and somehow manage")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" to answer their questions correctly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You let it slide. You let all my moods slide. You are confusing my neurosis for artistic depth again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You’ve learned the deeper you fall into me, the stickier I become, and the harder I am to leave. You will think you caught me, but you are the one who is stuck; I was never really here to begin with.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer119"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  }), _vm._v("Twenty2")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Each day as I am rushing through my life, the key to")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("  my parents’ house jingles on my keychain. The  chiseled metal opens a portal to home. To my  yesterdays. To my family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("To the familiar.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Each day I touch this key, see this key, and think to  myself, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I should really visit home.")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Yet, I cannot remember for the life of me the last time this key turned in its lock. I cannot recall the last time I saw the sign in the entryway.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("We’ll leave the light on for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I feel myself taking all that is 69.8 miles away for granted.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I should really visit home,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("life has been so hectic though,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("maybe next week.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer120"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  }), _vm._v("Sonder")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am fourth in line today at the doughnut and coffee ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shop on Bloomfield Avenue. The two guys at the  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("register see there are more Jets doughnuts remaining")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("than Giants. They surmise there must be more Giants")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fans in the area because of this, and I think their logic is sound.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The other guy in front of me is wearing black socks with sandals and has his hair slicked back. His attire and demeanor lead me to assume he works at the BMW dealership across the street. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Assumptions. That’s all we make.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We never really know the strangers around us, but  that doesn’t stop us from assuming something about them one way or another. I think it’s more human  curiosity than jumping to conclusions or judging.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The man with the slicked-back hair gets his coffee and ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I watch him walk back across the street to the  dealership. I peek over my shoulder and wonder for a  moment what the person behind me is assuming about me, but I shake it off. It does not matter.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer121"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  }), _vm._v("Limelight Breakup")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am really pissed")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I pay a therapist")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("for all this shit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That brown hair tie")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is definitely not mine,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you claim otherwise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Now I’m crying")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("because you’re lying")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("about your cell dying."), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You always hated")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that I was makin’")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("somethin’ of myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Jealous and frustrated")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was celebrated,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so you’d fuck someone else.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You found it all too stressful,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my being successful,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and grew resentful.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Were totally opposed")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to me working toward goals")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so you’d poke holes")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in my self-esteem,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you’d plot and scheme,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("break me with your deceit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You were never okay")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with the way")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was growing up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You would slip away")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and then you’d complain, "), _c('br'), _vm._v("say I didn’t care enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Never met a man")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so narcissistic,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so chauvinistic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was your fan,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but you,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you were my critic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And now,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we’re finished.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer123"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  }), _vm._v("Save—Don’t Save—Cancel")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("All the things I’ve wanted to tell you since you left are lodged inside my throat and in half-dialed numbers ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and e-mail drafts. Like how it’d be easier to move on")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("  if the only marks you left on my life were scars; but ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the beautiful imprint you left on my heart will remain ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("long after your pillow regains its shape.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I want you to know that even foreign elevators and hotel lobbies smell like you, but your ghost doesn’t  live here anymore. And just the other day, I saw my ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shadow for the first time in what feels like a lifetime")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".  It was as if it appeared just to convince me that though I may feel one-dimensional right now,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I am still flesh and bone and here.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And with each day that passes, I become more strong, more fierce. And with each day that passes, my heart forgets you a little bit more.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer124"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  }), _vm._v("Loose Threads Get Lost")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sit at my desk and notice a thread has come loose in")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" the hem of my dress. All I do is pull it once, with not much effort, and the thread is separated from the fabric. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("At first, to the naked eye, it does not seem as though ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the rest of the dress has been affected, but the material")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" knows and begins to fall apart between each wear  and wash, slowly at first, then all at once.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can’t help but wonder if the dress would have  survived had that one thread not come loose. Thread is not made of steel or wood but a material one can bite through with ease, split between just two ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fingers. Is a thread, so hairline thin, so fragile, capable")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" of separating an entire entity?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Yes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I like to think families are stitched together by  invisible threads. Some whose lengths extend down familiar hallways, others that span across miles and continents; but they are sewn together nonetheless, connected through blood and tears and laughter and birthdays.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Life has a tendency to pick at these threads—for   better or for worse. Things happen and they are  tightened, brought closer together; things happen and they are torn apart, ripped at the seams. Just like my dress, a family’s stitching can be altered.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Some things destroy a family’s fabric more than  others. A family’s undoing is not a beautiful  disentanglement, but an ugly severance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can’t help but wonder if the family would have  survived had that one thread not come loose.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer126"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  }), _vm._v("My Fifth Sense")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When you and I met,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you smelled of summer")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("at the Jersey Shore and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I wanted to bottle up the")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("entire four seconds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I felt my world shift.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I felt my heart expand")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and change and make room.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was the first time")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was acutely aware that")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("what was playing out in front of me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("would permanently change my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I felt it all—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my pounding heart,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("your piercing eyes;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my nervousness added")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to the stickiness of the humidity in the air.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was woken up that day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was as if I had slept through")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the other three seasons")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and had just opened my eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in the dead heat of July.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer127"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  }), _vm._v("Everyone Else, Then Me")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Our lives are just going in different directions,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tyou said, with little inflection.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("We are just in different places right now,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tyou added, then walked out.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Honey, there will be others,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tpromised my mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("When it comes to true love, you’ll just know it,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\twrote a cliché-riddled poet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("You can do so much better,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tscribbled a friend, in a letter.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("You are stronger than you think,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tdiagnosed my shrink.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Ten years is nothing, you’re still so young,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\ta math equation, from someone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I know someone who would be perfect for you,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tanother friend said, from her point of view.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("I will cry myself dry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("\tI will survive.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l4"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("\t\tI will thrive,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l6"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\t\t\tsaid my voice,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l6"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\t\t\tfrom deep inside.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer128"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  }), _vm._v("Ortley Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My toes have danced in many oceans.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My arms and legs have waded in many waters.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My mind has imagined reaching their horizons.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Still, nothing compares to my ocean,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("whose tides I have known my whole life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whose winter temperatures never kept me away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whose whitecaps wrapped around my skin.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whose sprays cleansed, never stung.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whose seas healed my cuts and broken hearts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whose waves I swam in with my father.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whose sand collected in my bathing suits")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and in my family’s drains.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whose waters watched me grow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whose salt helped shape my molecules")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and played a distinct role in who I became.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This small piece of a vast ocean")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("raised me—her changing tides")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("assured me that even at my lowest,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I, too, would rise again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Just trust time,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" she would sing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The moon will reset us both.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer129"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  }), _vm._v("Marie")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can’t remember how you used to say my name. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Which sounds ridiculous because I still remember my ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" name, of course, and the sound of your voice; but I  can’t close my eyes and hear you say those three  syllables anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The tone, the inflection, the warmth.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Even more strange, I do clearly remember the way you used to utter those nicknames you gave me; like when you would call me by my middle name. But not my name, and the harder I try to conjure it, the more distant your echo becomes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It’s barely a whisper now. White noise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Maybe that is a good thing. Maybe another saying my name over and over ever since I fell in love again has finally drowned you out of my psyche. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer130"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  }), _vm._v("Barnegat Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Even though I sit here with my solitude, I am not  lonely. When you have good memories stowed away, you’re never really alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A lifetime of reminiscences keep me company today as the rain plays its music on water’s surface. I am perched at the front of the dock, my feet float freely off the ledge of the pier. My father used to take me  here to catch crabs with drop lines. The water laps ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("against the post, even spraying me from time to time. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" I lick the salt from my lips. I breathe in the smell of  the bay at dusk. The smell would cause some to scowl, to pinch their noses. I suppose the smell could ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("be repulsive, if it weren’t tied into my bloodstream and ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("genesis.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer131"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  }), _vm._v("Palermo")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The tour guide keeps mentioning the blending of ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("the  old and the new")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" in the city. ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The old,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" beautiful ivy ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("balconies, five-ton chandeliers, and streets of marble")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".  ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The new,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" graffiti attacking their government and police, litter in the streets.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Stray dogs run rampant but don’t really run. They  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("just lie there because they are too weak. We buy a loaf ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" of bread out of the trunk of a man’s car for one euro and spend the rest of the afternoon ripping pieces from it and tossing it to the animals.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A homeless man gets a hold of a piece")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and shares it with a dog.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The best may already be behind us,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but humanity is still here.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer132"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/GettyImages-104633675_jb_left.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame l2",
    attrs: {
      "id": "_idContainer133"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Leftn ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  }), _vm._v("I’ll Take It (A Duet)")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Featuring Codey Bearden & Arrie Bozeman")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I met a tall boy who played the drums,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I never even learned his last name.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But his tongue lit me like a flame,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and that’s enough to call it love.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I saw you walk into the room,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("not the same ol’ twist of fate.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("If there’s a Heaven, well I found the gate,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and that’s enough to call it love.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He jumped from city to city,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I just knew we wouldn’t make it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He said my eyes were pretty,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if there’s a chance of love, I’ll take it")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We didn’t have to last forever,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to be makin’ this beautiful music together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Here we are on the front porch swingin’")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I play the music, you do the singin’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t know how this story goes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but if you give me this dance,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ll take it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He liked my voice and the rips in my jeans,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("told him I liked to sing my own songs")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("mostly about where I’ve gone wrong,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and he called me the girl of his dreams.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You came back to the show the next week.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I saw you singin’ along.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Knew every word to every song,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can’t tell if I’m awake.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She wore all those fancy clothes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Miss Corporate in some big buildin’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She didn’t mind my flip-flop toes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the future’s in her eye, God willin’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We didn’t have to last forever,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to be makin’ this beautiful music together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Here we are on the front porch swingin’")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I play the music, you do the singin’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t know how this story goes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but if you give me your hand,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ll take it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Still, you come to see me play.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tA couple years gone by,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it’s our ten-year anniversary,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left l2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\tand you still blow my mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We didn’t have to last forever,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to be making this beautiful music together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Here we are on the front porch swingin’")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I play the music, you do the singin’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t know how this story goes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but if you give me your heart,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ll take it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This could go on forever,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("makin’ this beautiful music together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Listen to “I’ll Take It (A Duet)”: "), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.thealiciacook.com/codeybearden",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("www.thealiciacook.com/codeybearden")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer136"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  }), _vm._v("Apple Skin Stuck Between Teeth")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Before tonight, the last time I baked an apple crisp, it  was for you and I forgot to peel the apples so they went in, skin and all. You ate it anyway even though you and I both knew it wasn’t my best. In hindsight, spitting out apple flesh together on the couch that night seems fitting because you weren’t the best version of yourself when you ate it and I wasn’t the best version of myself when I made it and we weren’t the best version of us when we were sitting there, legs crossed, together. So now, as I slide my latest apple crisp out of my new oven in my new home, I can tell by the smell of the warmth that this one is the best I’ve ever made—which seems fitting because I am finally the best version of myself, too.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer137"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  }), _vm._v("More Cherry Blossoms Than D.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Where winter slammed into my body, leaving bruises")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("  and soreness behind, spring made love to me. Melted, slowly, into my marrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You place a cherry blossom behind my ear and say it matches my dress and lips.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We take refuge from reality under the pink trees  in Branch Brook Park that will only stay as beautiful as this for another two days.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The wind dances with the branches and the petals rain down, and we pretend they are velvet raindrops falling from the sky.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’s magic to be found in days that begin quite ordinarily if you just open yourself up to possibilities. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer138"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  }), _vm._v("EWR -> BCN")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We are having dinner together at the airport before our flight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can’t gaze lovingly into your eyes, even if I wanted to, because obstructing our views of each other are two tablets.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Please place your orders through these tablets. You can also play games on them while you wait for your meal. But you can’t play against one another; the tablets  are not synced together. They don’t communicate,  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("explains the server.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("We are all so disconnected")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", I respond.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We order a $42 bottle of red wine that retails at $9 and")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" entrees through the device, not the person I am  supposed to be tipping at 20 percent.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("We are all so disconnected.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("As we eat, a blaring alarm goes off throughout the  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("airport and continues to scream throughout the whole")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" meal.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("We’re not in 2001 anymore, Toto")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sixteen years ago, this would have caused mass panic and hysteria, but in 2017, not one person flinches.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("We are all so disconnected.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer139"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  }), _vm._v("Counting Sirens")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have my cheap headphones in my ears, so I hear the")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" boat’s motor and the late-summer wind over my  music. The sky matches the water today.")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It is hard to tell where the horizon line sleeps. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("If somber had a color, it would be gray.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I appreciate the irony when I see the ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("no wake zone ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("signs bobbing violently as we approach the Thomas J. Mathis Bridge. Cars roar above us like extinct  creatures.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It is the type of hazy day where my mother would warn us about applying sunscreen. Clouds momentarily break and the water sparkles. We used to say mermaids swam beneath wherever the water glistened.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I count the sun glitter patches to myself until I lose count.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Five thousand mermaids, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I estimate, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("are swimming alongside my heart today. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer140"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/GettyImages-104633675_jb_left.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame l2",
    attrs: {
      "id": "_idContainer141"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Leftn ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  }), _vm._v("Told Myself")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Featuring Carly Moffa")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I dreamt of you in a reclusive way,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("imagined us to be timeless.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But you were never really here,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("your eyes were always off chasing dragons.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You responded in an elusive way,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("nonchalant and indecisive.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("On our one-way trip to nowhere,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I pretended to not hear your silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I wish I never met you,”")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a phrase I could never get through.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Told myself")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("even if our ending couldn’t change,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I would still do everything the same,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("because touching you for that long")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was better than never touching you at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Built us up in a delusive way,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("stargazing from the cold basement.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We forgive those with serpent spines,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it’s the fault line of our generation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You led me on in an abusive way,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("played my idiosyncrasies.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My love of weaving lies in rhymes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my torrid affair with hyperbole.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I wish I could forget you,”")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a lie designed to upset you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Told myself")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if I saw true colors through gray,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I would grab my heart and run away,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("because loving you for that long")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("doesn’t count if it was never love at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then, I forgot you in a human way,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("became strong when it mattered most.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My heart, it became my weapon,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("drew a line in the sand, planned my revolt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then, you mourned me in a consuming way,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("crushed you with the weight of my ghost.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You finally learned your lesson")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("when ash from last words got caught in your throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I changed, come back, I beg you,”")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a plea meant to make me swoon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Told myself")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d never again dream of your face,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I haunt you all over the place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I needed you here for so long,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and now I do not need you here at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Listen to “Told Myself”: ")]), _c('a', {
    attrs: {
      "href": "http://thealiciacook.com/carlymoffa/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("www.thealiciacook.com/")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("carlymoffa")])])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer143"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  }), _vm._v("An Untrained Eye Will Miss Everything")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Life is split into ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("before")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" and ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". We capture the ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("befores")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" while they are ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("nows")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" in photographs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I keep a photo tucked into my dresser mirror. On the surface, there is nothing remarkable about this photo of me and two people I love smiling under my  mother’s favorite tree in the backyard.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("By the budding blossoms, I will always remember this photo was taken in early spring. On the precipice of not having to wear tights beneath dresses.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There is nothing remarkable about this photo of me and two people I love smiling under my mother’s  favorite tree in the backyard. By the easy smiles on  our faces, I can tell this was the last early spring  before everything changed. That was the last photo taken before everything changed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There is nothing remarkable about this photo of me and two people I love smiling under my mother’s  favorite tree in the backyard. The photo is not  centered or as focused as some of the photos we have taken since that day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Not all the changes since have been bad. However, we no longer smile that effortlessly anymore. I let this photo of me and two people I love smiling under my mother’s favorite tree in the backyard greet me each morning because someone told me once we live life forwards but remember it backwards and that was  one backwards day where I remember everything was actually fine. I like to remember we existed like ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that once. Actually fine. It gives me hope that we can")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" one day be that way again. Actually fine.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer145"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  }), _vm._v("70 in December")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Featuring Christina Hart (")]), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/christinakaylenhart/?hl=en",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("@christinakaylenhart")])]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I cannot keep up with the traffic")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in the left lane of the Turnpike today.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Maybe the sappy song on the radio")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is slowing down my pace.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whatever the reason,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I keep having to get over one lane")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to allow for the faster cars to zip by.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We are nearing the holidays and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it’s seventy degrees and sunny.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Why is everyone in such a rush?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I want to take my time with today,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("especially since the forecast is")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("calling for winter tomorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They say our hearts will")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("thaw out sometime")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("near spring and")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the weather is just another")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("thing for us to avoid.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I cannot keep up with the")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sweeping up of all the")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("things we should be saying.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It is too warm today")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and tomorrow will be too cold")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and the next day will come too soon")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and will we ever really be satisfied with right now?")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer146"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  }), _vm._v("You Are Not the Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The pictures no longer cause my stomach to drop into my feet. I no longer search for your fingerprints on things around the house just to remind myself that we shared time and space. I no longer experience what could only be explained as ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("the heartbreak sweats")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("; the elevated breathing, the nausea.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I do not love you anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I do not miss you anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am not angry with you anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But, most importantly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am no longer angry with myself for shrinking my  size and talent just so you could feel tall. I am no  longer angry with myself for downplaying my  aspirations and accomplishments just so you could take center stage.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I spent so much time trying to be less.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Less driven.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Less acknowledged.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Less than you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I couldn’t be contained.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I no longer live in a world")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that revolves around your ego.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You are not a life source.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You are not the sun.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It’s the best feeling in the world to know")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I haven’t just moved on,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve eclipsed you.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer148"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  }), _vm._v("A Clandestine Operation")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We dress in plain clothes. We order coffee at the same café you frequent. We pick up the dry cleaning and  go food shopping. We get up every morning and start our day. Just like you, we forget our umbrellas when we need them most. We fold towels and put socks away. We are unassuming and welcome flying under the radar. There are a lot of us out there. You might  have to ask ten questions before you discover what rages beneath our surfaces. You’d never know what we’ve done simply by looking at our faces, but we can identify one another with ease.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We are survivors.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We survived even when the ones we loved did not. We survived even when we thought we couldn’t last another day, another minute, another second. We survived even when those closest to us believed we wouldn’t")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" . . . ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("couldn’t.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We faced the worst and beat the odds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We faced the worst and didn’t become a statistic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We faced the worst and lived to tell our tales.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer149"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/GettyImages-104633675_jb_left.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 l2",
    attrs: {
      "id": "_idContainer150"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Leftn ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  }), _vm._v("Footprints")])]), _vm._v(" "), _c('p', {
    staticClass: "Featuring"
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Featuring Codey Bearden")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve never been the smartest")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one in any room,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I know if I work hard, I’ve")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("seen what I can do.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It’s the same old block I’ve walked")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("at least a time or two,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and it keeps going.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m just trying to let you know:")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t want to be famous, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that’s not to say the stars")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("aren’t where I’m aimin’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Walkin’ ’round this world with")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("no shoes but a lot of soul,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("just trying to leave a")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("little footprint when I go.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’s been times I thought for sure")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that I was done,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fell flat on my face before")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I had begun.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Not every swing I take")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will be a home run, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I’ll keep swinging.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Seen dreams wash down the gutter")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in front of my eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Spent time on my knees prayin’")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("for stars to align. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’ve run for days to end back")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("at the starting line, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I keep runnin’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They pushed me down, then said I fell.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I got back up without their help.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Threw all I had in a wishing well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Want to leave my mark, raise some hell.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m striving for greatness, but")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t want to be famous, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that’s not to say the stars")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("aren’t where I’m aimin’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Walkin’ ’round this world with")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("no shoes but a lot of soul,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("just trying to leave a")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("little footprint when I go.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t1 _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Listen to “Footprints”: ")]), _c('span', {
    staticClass: "Listen-To--Song- CharOverride-1"
  }, [_c('br')]), _c('a', {
    attrs: {
      "href": "http://www.thealiciacook.com/codeybearden",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("www.thealiciacook.com/codeybearden")])])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer152"
    }
  }, [_c('p', {
    staticClass: "Poem-Head-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  }), _vm._v("I Hope My Voice Doesn’t Skip")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When there is nothing left to say,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you       stop.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You        take in a breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You        let out a breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You        listen.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Do not stutter through made-up words for the sake of hearing your own voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When there is nothing left to say,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you        leave.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Do not stumble through made-up words for the sake of holding on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When there is nothing left to say,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you        let go.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You do not allow your heart to suffer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It has been too good to you to allow it to suffer.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer153"
    }
  }, [_c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3 t3"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("The")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("End")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer154"
    }
  }, [_c('p', {
    staticClass: "Ebook-TOC",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  }), _vm._v("Liner Notes")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This book began like all my other work: scattered. Jotted down on napkins and in various notebooks and e-mail drafts, recorded in voice memos. It came together thanks to so many amazing people I am  fortunate enough to call my family, friends, and  colleagues.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("First, my parents. Growing up, I never realized how rare it was to have parents who had my back and  who supported my artistic ventures until I landed in the creative world and learned many parents didn’t believe their kids could “make it” as creatives. You ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("guys never wavered, your faith in me never lessened. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("You never suggested I study anything other than  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("literature and journalism. I want to thank you for that")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" because if you tried to steer me in another direction when I was younger, I may not have the life I have today, and that would be terribly sad, because I love my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Mom, in a world of “yes men” you are my guidepost. Your honesty on all of this work was blunt and necessary. I’ll never forget in November 2016 when you told me to throw the whole manuscript out and start over. You told me not to “force it,” to take my time, and to just live my life. I took your advice, and I am happy I did. I am so proud of this body of work. You are my first and most trusted editor.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dad, I want to thank you for playing your records, (yes,  even the times you blasted Pavarotti over the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("intercoms at 6 a.m.). Thank you for exposing me to all ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("different artists and styles, from the crooners to disco to classic rock to doo-wop. People laugh when I tell them the first CD I ever bought with my “own  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("money” was Tony Bennett’s ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Perfectly Frank, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I am")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" so glad! You instilled in me the importance of  knowing the artist and not just memorizing the lyrics. I remember when you would quiz me, “Who sang this?” “Who wrote that?” “What was Sinatra’s ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("nickname?” “What movie did ‘Steppin’ Out With My ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Baby’ appear in?” This trivia made me curious to learn more about the life of the artist—the story behind the song.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To the rest of my family, especially my sister, Kellie, I want to thank you all for just “getting” it. For  understanding, from all the way back when we were ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("kids filming movies I directed in our basement, that I")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("  was going to create for a living, which would mean writing about our lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To my Michael and his fam-jam (except you, Ant,  because you are ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("the worst")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("), I feel your excitement  daily, and it means the world to me that you have  embraced this crazy journey. Thank you for rooting for me. I love you all (except Ant).")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To Jess Cook—my cousin in Heaven—this is all  actually happening. Can you believe it?!")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To my ever-so-patient friends who have yet to shun  me for lapsing on returning phone calls and/or texts—I love you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To my girl, J.R. Rogue, who appears in this book, I will say this ’til the day I die: You are the best writer  to ever do this thing. Oh, and to you and Ms. Kat  Savage—thank you for creating such amazing writing prompts. The results of a few ended up in this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To the musicians who donated their time and talent to this vision: Ada Pasternak, Highland Kites, Codey Bearden and Arrie Bozeman, Taylor Belle, Caitlin  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Mahoney, Christopher Andrews, Carly Moffa,  Kristin Michelle Elizabeth, and Renee Mazza. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" This book wouldn’t be what it is without each of you.  I am forever indebted you returned my messages.  I hope we keep creating together. You deserve ALL  the streams and Grammys. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To Jordan Emanuel for connecting me with the ever-so-talented Caitlin Mahoney. There’s nothing better than women supporting women.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To Christina Hart, the first writer to read this  collection and provide the feedback only another writer could provide: THANK. GOD. FOR. YOU. I  am so happy we had a chance to write together on  this one. Next round of ridiculously portioned nachos is on me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To Adam Castro ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("mostly")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" for coming up with the titles “Hypnic Jerk” and “Traffic, Signs.” You are great. RANKED.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To the Andrews McMeel Publishing team, especially")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("  Patty, for taking a chance on me back in 2016 and again in 2018; and to my agent, Byrd, for emailing me two years ago and for having an even cooler name. Let’s keep doing this. It’s fun.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lastly, to the READERS. What did I do right to  deserve all of you? You’re all so awesome and  ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("passionate. I love keeping up with all of you on social")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("  media and chatting about music and Buffy and  everything else. I hope this book resonates with you  as much as ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Stuff I’ve Been Feeling")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Lately")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" did. This one,  honestly, is even closer to my heart. Even more  personal. I hope it helps you feel less alone and more understood. I wouldn’t be living out this dream if it weren’t for every single one of you. I am so excited to finally get this collection in your hands, and  hopefully in your hearts as well! Stick with me.  I won’t let you down.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer158"
    }
  }, [_c('p', {
    staticClass: "Ebook-TOC",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  }), _vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Alicia Cook is an established writer and award-winning activist living in New Jersey whose work has been seen on HuffPost, USA Today, Bustle, and CNN, to name a few.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Named one of the best “Instagram poets” by ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Teen Vogue,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" her poetry is usually unfixed and covers  various topics and emotions, most notably grief. Her bestselling book of poetry, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Stuff I’ve Been Feeling Lately,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" was a finalist in the 2016 Goodreads Choice Awards. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Cook, the 2017 recipient of the “Special Voices”  award in Trenton, advocates to break the stigma ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("surrounding families affected by drug addiction. Her")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" essay series, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("The Other Side of Addiction,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" written in honor of her cousin Jessica Cook, has developed a worldwide readership. Her efforts were featured on the episode “A Family Disease” by the Emmy-nominated documentary series ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Here’s the Story.")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" The episode has gone on to be nominated in several film festivals. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Cook is currently the Director of Institutional  Communications and Campaign Marketing at Bloomfield College. In 2017, ")]), _c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("On the Green")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", the magazine she writes for the College, won the \n\t\t  platinum award in the MarCom Awards, the \n\t\t  organization’s highest honor.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Cook earned a bachelor’s degree (2008) in English Literature with a concentration in Journalism and a master’s degree in Business Administration with a concentration in Risk Management (2012).")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer160"
    }
  }, [_c('p', {
    staticClass: "Ebook-TOC",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  }), _vm._v("Also by Alicia Cook:")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('a', {
    attrs: {
      "href": "http://publishing.andrewsmcmeel.com/catalog/detail?sku=9781449487560",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Stuff I’ve Been Feeling Lately")])])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('a', {
    attrs: {
      "href": "https://www.amazon.com/Heroin-Worst-Thing-Ever-Happen/dp/1540423263",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("Heroin is the Worst Thing to Ever Happen to Me")])])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t1"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("Follow Alicia:")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer161"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "alt": "",
      "src": "image/instagram.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/thealiciacook/?hl=en",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("@thealiciacook")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer162"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "alt": "",
      "src": "image/tumbler.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/the_alicia_cook?lang=en",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("@the_alicia_cook")])])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.thealiciacook.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Poem-Body-Italic CharOverride-2"
  }, [_vm._v("www.thealiciacook.com")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer163"
    }
  }, [_c('div', {
    staticClass: "blank"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9 t3"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("#ihopemyvoicedoesntskip")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer164"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-17"
  }, [_vm._v("I Hope My Voice Doesn’t Skip")]), _c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v(" copyright © 2018 "), _c('br'), _vm._v("by Alicia Cook. All rights reserved. No part of this book may "), _c('br'), _vm._v("be used or reproduced in any manner whatsoever "), _c('br'), _vm._v("without written permission except in the case "), _c('br'), _vm._v("of reprints in the context of reviews.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("Andrews McMeel Publishing"), _c('br'), _vm._v("a division of Andrews McMeel Universal"), _c('br'), _vm._v("1130 Walnut Street, Kansas City, Missouri 64106")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('a', {
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("www.andrewsmcmeel.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("ISBN: 978")]), _c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("-")]), _c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("-")]), _c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("449")]), _c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("4-9")]), _c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("682-1")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("Library of Congress Control Number: ")]), _c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("2017962449 ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('a', {
    attrs: {
      "href": "http://iStock.com/Emilia_Szymanek",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("iStock.com/Emilia_Szymanek")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("Editor: Patty Rice"), _c('br'), _vm._v("Art Director: Julie Barnes"), _c('br'), _vm._v("Production Editor: Elizabeth A. Garcia"), _c('br'), _vm._v("Production Manager: Cliff Koehler"), _c('br'), _vm._v("Ebook Developer: Kristen Minter")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("ATTENTION: SCHOOLS AND BUSINESSES "), _c('br'), _vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase for educational, business, or sales  promotional use. For information, please e-mail the  Andrews McMeel Publishing Special Sales Department: ")]), _c('a', {
    attrs: {
      "href": "mailto:specialsales@amuniversal.com"
    }
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("specialsales@amuniversal.com")])]), _c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer167"
    }
  }, [_c('p', {
    staticClass: "Ebook-TOC",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  }), _vm._v("Other titles from Andrews McMeel Publishing")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('a', {
    attrs: {
      "href": "http://publishing.andrewsmcmeel.com/books/detail?sku=9781449492793",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1t",
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "alt": "",
      "src": "image/9781449496708.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://publishing.andrewsmcmeel.com/catalog/detail?sku=9781449492984",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1t",
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "alt": "",
      "src": "image/9781449496661.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('a', {
    attrs: {
      "href": "http://publishing.andrewsmcmeel.com/catalog/detail?sku=9781449492878",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1t",
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "alt": "",
      "src": "image/9781449492878.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://publishing.andrewsmcmeel.com/catalog/detail?sku=9781449495497",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1t",
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "alt": "",
      "src": "image/9781449496685.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa66d7d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VoiceDoesntSkip_mobi_epub.vue
// module id = 60
// module chunks = 0